import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { useSelector } from "react-redux";
import { delay } from "../../../helpers/helperfunctions";
const BotMessageRenderer = (props) => {
  const vaState = useSelector((state) => state.vaStateStore.vaState);
  const [state] = useState({
    theme: vaState?.theme,
    divId: uuidv4(),
    messageActivity: props.messageActivity,
  });
  useEffect(() => {
    console.log("Message Card to render", state.messageActivity);
    setTimeout(async () => {
      let botMessageDiv = document.getElementById(state.divId);
      if (botMessageDiv === null) {
        await delay(100);
        botMessageDiv = document.getElementById(state.divId);
        if (botMessageDiv === null) {
          await delay(100);
          botMessageDiv = document.getElementById(state.divId);
        }
      }
      const messageBubbleElement = botMessageDiv?.querySelector(
        "div.webchat__bubble__content"
      );
      if (messageBubbleElement) {
        messageBubbleElement.classList.add(`${state.theme}-bot-message-bubble`);
      }
      const animatedAvatars = document.querySelectorAll(
        `div.${state.theme}-bot-message-avatar-animated`
      );
      animatedAvatars?.forEach((element) => {
        element.classList.replace(
          `${state.theme}-bot-message-avatar-animated`,
          `${state.theme}-bot-message-avatar`
        );
      });
      const messageAvatar = botMessageDiv?.querySelector(
        `div.webchat__stacked-layout__message-row`
      );
      if (messageAvatar) {
        messageAvatar.classList.add(
          `${state.theme}-bot-message-avatar-animated`
        );
      }
    }, 0);
  }, []);
  return <div id={state.divId}>{state.messageActivity}</div>;
};

export default BotMessageRenderer;
